<soft-master-detail-page
  backNavigationPath="/"
  [masterTemplate]="masterTemplate"
  [masterHeaderTemplate]="masterHeaderTemplate"
  [detailTemplate]="detailTemplate"
  [items]="filteredTickets()"
  [(activeItem)]="selectedTicket"
  [idFunction]="idFunction"
  [loading]="loading()"
>
  <ng-template let-data #masterTemplate>
    <div class="flex flex-col font-sans text-sm px-2 md:pl-0 lg:px-2 py-2 w-full">
      @if (((accountIdsLength$ | async) ?? 0) > 1) {
        <div class="soft-overline">
          {{
            data?.customer ? data?.customer?.number + ' - ' + data?.customer?.name : ''
          }}
        </div>
      }
      <div class="flex flex-row justify-between">
        <h6 class="font-semibold">
          {{ '#TICKETS.OVERVIEW.TICKET' | translate }} {{ data?.id }}
        </h6>
        <div
          [softToolTip]="contacts"
          class="pr-2 cursor-pointer"
        >
          <soft-icon name="fa-regular fa-users"></soft-icon>
        </div>
      </div>

      <ng-template #contacts>
        <h5 class="font-bold">{{ '#TICKETS.PROPERTIES.CONTACTS' | translate }}</h5>
        @for (group of $safeNavigationMigration(data?.contacts) | groupBy: 'type'; track group) {
          <div class="mt-1">
            <b>{{ $any(group).key | contactType | translate }}</b>
            @for (contact of group | toArray; track contact) {
              <div>
                {{ $any(contact).contact.firstName }} {{ $any(contact).contact.lastName }}
              </div>
            }
          </div>
        }
      </ng-template>

      <p class="ticket-name font-light">{{ data?.name }}</p>

      <div class="flex flex-row">
        <div class="caption" [innerHTML]="$safeNavigationMigration(data?.type?.description)"></div>
        <div class="caption">&nbsp;-&nbsp;{{ data?.step }}</div>
      </div>

      <div class="flex flex-row">
        <div class="caption">
          {{ '#TICKETS.OVERVIEW.CREATED' | translate
          }}{{ $safeNavigationMigration(data?.created) | format: 'DATE.DEFAULT' }}
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #detailTemplate>
    <soft-ticket-details [ticket]="selectedTicket()"></soft-ticket-details>
  </ng-template>
</soft-master-detail-page>

<ng-template #masterHeaderTemplate>
  <soft-input
    id="ticket-search"
    [icon]="'fa-regular fa-search'"
    [placeholder]="'#TICKETS.OVERVIEW.SEARCH' | translate"
    [(value)]="searchValue"
  />
</ng-template>

<ng-template #menuBarChipsTemplate>
  @if (queryParams(); as query) {
    <!-- @if (query?.id && tickets().length === 1) {
      <soft-chip
        class="chips-spacing"
        [canDelete]="true"
        (delete)="removeQueryProperty($any(query), 'id')"
      >
        <strong>{{ '#TICKETS.QUERY.ID' | translate }}</strong> {{ query.id }}
      </soft-chip>
    } -->
    @if (query.description) {
      <soft-chip
        class="chips-spacing"
        [canDelete]="true"
        (delete)="removeQueryProperty($any(query), 'description')"
      >
        <strong>{{ '#TICKETS.QUERY.NAME' | translate }}</strong>
        {{ query.description }}
      </soft-chip>
    }
    @if (query?.from) {
      <soft-chip
        class="chips-spacing"
        [canDelete]="true"
        (delete)="removeQueryProperty($any(query), 'from')"
      >
        <strong>{{ '#TICKETS.QUERY.FROM' | translate }}</strong>
        {{ query.from | date: 'dd.MM.yyyy' }}
      </soft-chip>
    }
    @if (query?.to) {
      <soft-chip
        class="chips-spacing"
        [canDelete]="true"
        (delete)="removeQueryProperty($any(query), 'to')"
      >
        <strong>{{ '#TICKETS.QUERY.TO' | translate }}</strong>
        {{ query.to | date: 'dd.MM.yyyy' }}
      </soft-chip>
    }
    @if (query.fromPriority || query.toPriority) {
      <soft-chip
        class="chips-spacing"
        [canDelete]="true"
        (delete)="removeQueryProperty($any(query), 'fromPriority', 'toPriority')"
      >
        <strong>{{ '#TICKETS.QUERY.PRIORITY' | translate }}</strong>
        {{ query.fromPriority || 1 }} - {{ query.toPriority || 9 }}
      </soft-chip>
    }
  }
</ng-template>

<ng-template #menuBarFilterTemplate>
  @if (all().length !== 1 && selectedFilter(); as filter) {
    <strong class="mr-1">{{ '#TICKETS.QUERY.FILTER' | translate }}</strong>
    <soft-menu-bar-picker
      [value]="filter"
      (valueChange)="onSelectFilter($event)"
      tooltip="Filter"
    >
      @for (option of filters(); track option.id) {
        <soft-picker-option [title]="option.name" [value]="option" />
      }
    </soft-menu-bar-picker>
  }
  @if (all().length === 1 && !loading()) {
    <button
      type="button"
      class="soft-button accent text-accent-contrast rounded hover:cursor-pointer"
      (click)="resetFilters()"
    >
      Alle offenen Tickets anzeigen
    </button>
  }
</ng-template>

<!--
<div [class.!hidden]="masterDetail.view() === 'detail'" class="soft-top-container !pb-0 !grid gtc-1 gtr-2 gtc-m-4 gtr-m-1" #header>
  <div class="gr-1 gc-1 gc-m-1-2" >
    <ng-container *ngIf="query$ | async as query">
      <div class="flex flex-col">
        <strong>{{ '#TICKETS.OVERVIEW.APPLIED_FILTERS' | translate }}</strong>
      </div>
      <soft-chip-group class="flex flex-row mt-1">
        <soft-chip class="chips-spacing" *ngIf="query.id" [canDelete]="true" (delete)="removeQueryProperty($any(query), 'id')">
          <strong>{{'#TICKETS.QUERY.ID' | translate}}</strong> {{query.id}}
        </soft-chip>
        <soft-chip class="chips-spacing" *ngIf="query.description" [canDelete]="true" (delete)="removeQueryProperty($any(query), 'description')">
          <strong>{{'#TICKETS.QUERY.NAME' | translate}}</strong> {{query.description}}
        </soft-chip>
        <soft-chip class="chips-spacing cursor-pointer" *ngIf="filter$ | async as filter" (click)="openFilterDialog()">
          <strong>{{'#TICKETS.QUERY.FILTER' | translate}}</strong> {{filter.name}}
        </soft-chip>
        <soft-chip class="chips-spacing" *ngIf="query?.from" [canDelete]="true" (delete)="removeQueryProperty($any(query), 'from')">
          <strong>{{'#TICKETS.QUERY.FROM' | translate}}</strong> {{query.from | date:'dd.MM.yyyy'}}
        </soft-chip>
        <soft-chip class="chips-spacing" *ngIf="query?.to" [canDelete]="true" (delete)="removeQueryProperty($any(query), 'to')">
          <strong>{{'#TICKETS.QUERY.TO' | translate}}</strong> {{query.to | date:'dd.MM.yyyy'}}
        </soft-chip>
        <soft-chip class="chips-spacing" *ngIf="query && ((query.fromPriority ?? 0) > 1 || (query.toPriority ?? 0) < 9)" [canDelete]="true" (delete)="removeQueryProperty($any(query),'fromPriority', 'toPriority')">
          <strong>{{'#TICKETS.QUERY.PRIORITY' | translate}}</strong> {{query.fromPriority || 1}} - {{query.toPriority || 9}}
        </soft-chip>
      </soft-chip-group>
    </ng-container>
  </div>
  <label for="ticket-search" class="gr-2 gc-1 gr-m-1 gc-m-3-4 mt-1" style="width: 100%;">
    <input class="soft-input"
      id="ticket-search"
      placeholder="{{'#TICKETS.OVERVIEW.SEARCH' | translate}}"
      (input)="search$.next(value.value)"
      (keydown.enter)="findTicket(+value.value)"
      #value>
  </label>
</div>

MASTER DETAIL VIEW
<div class="mt-2 flex flex-grow flex-col overflow-hidden full-width pr-4">
  <soft-master-detail class="h-full"
    [ngClass]="((loading$ | async) ?? false) ? 'pl-2' : 'pl-0'"
    [data]="(filteredTickets$ | async) || []"
    (selectedChange)="onSelectedChange($event)"
    [masterTemplate]="masterTemplate"
    [detailTemplate]="detailTemplate"
    #masterDetail>
  </soft-master-detail>
</div>
-->
